export default __webpack_public_path__ + "static/media/heart.eded9572.webp";